import React, { useCallback, useEffect, useRef, useState, useMemo, useContext } from 'react';
import { navigate } from 'gatsby';
import { apiHolder as api, apis, locationHelper, MailSettingKeys, } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import useMailStore from '@web-mail/hooks/useMailStoreRedux';
import { MailActions, useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import useMsgCallback from '@web-common/hooks/useMsgCallback';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import moment from 'moment';
import { actions as mailTabActions, tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { filterTabMap, FLOLDER, LIST_MODEL, MAIL_STORE_REDUX_STATE, MAIL_TAG_GUIDE_LOCAL_KEY, MAIL_HOTKEY_MODULE_TYPE, MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY, } from '../../common/constant';
import { folderCanSortByTop, getFilterCondParams } from '../../state/customize';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
import useState2RM from '../../hooks/useState2ReduxMock';
import { isMainAccount, mailLogicStateIsMerge, promiseIsTimeOut, parseAccountFromAllFolderSubAccount, folderIdIsAllDraftFolder, folderIdIsAllSentFolder, folderIdIsAllFolder, folderIdIsAllTopFolder, simpleHash, transTag2Name, } from '../../util';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useDebounceEffect, useUpdateEffect } from 'ahooks';
import { MAIL_LIST_INIT_RANGE_COUNT, MAIL_LIST_MORE_RANGE_COUNT, MAX_MAILTOP_SUM, MAIL_FOLDER_SELECTED_LOCAL_KEY, } from '@web-mail/common/constant';
import useStateRef from '@web-mail/hooks/useStateRef';
import { getIn18Text } from 'api';
import { requestInQueue } from '@web-common/utils/utils';
import debounce from 'lodash/debounce';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { MailModuleHKContent, useRegistMailHK } from '@web-mail/components/ListHotKeys/moduleHotKey';
import { HotKeysType } from '@web-common/state/reducer/hotkeysReducer';
import { useLocation } from '@reach/router';
import { useGlobalEventObserver } from '@web-common/hooks/useEventObserver';
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const mailManagerApi = api.api.requireLogicalApi('mailConfApiImpl');
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const queueRequest = requestInQueue(3000);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const storageApi = api.api.getDataStoreApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MailBoxEventHander = props => {
    const reducer = useActions(MailActions);
    const mailTodoModal = useNiceModal('mailTodo');
    const currentTabAccountId = useAppSelector(state => { var _a; return (_a = state.mailTabReducer.currentTab.extra) === null || _a === void 0 ? void 0 : _a.accountId; });
    const mailTagHotKeysMap = useAppSelector(state => state.hotKeyReducer.mailTagHotKeysMap);
    const [expiredAccountList, setExpiredAccountList] = useState2RM('expiredAccountList', 'doUpdateExpiredAccountList');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const isAdvancedSearch = useMemo(() => mailSearching === 'advanced', [mailSearching]);
    const [listLoading, setListLoading] = useState2RM('listLoading', 'doUpdateMailListLoading');
    const refListLoading = useRef(false);
    refListLoading.current = listLoading;
    const [selectedSearchKeys, setSelectedSearchKeys] = useState2RM('selectedSearchKeys', 'doUpdateSelectedSearchKey');
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [tagName, setTagName] = useState2RM('mailTagFolderActiveKey', 'doUpdateMailTagFolderActiveKey');
    const [searchList, setSearchList] = useMailStore('searchList');
    const [mailDataList, setMailList] = useMailStore('mailDataList', { key: 'mailList', exclude: ['receiver'] });
    const [mailTotal, setMailTotal] = useState2RM('mailTotal', 'doUpdateMailTotal');
    const [activeIds, setActiveIds] = useState2RM('activeIds');
    const [selected, setSelected] = useState2RM('mailListStateTab', 'doUpdateMailListStateTab');
    const [dateRange, setDateRange] = useState2RM('orderDateRange', 'doUpdateOrderDateRange');
    const [searchSelected, setSearchSelected] = useState2RM('searchListStateTab', 'doUpdateSearchListStateTab');
    const [inputValue, setInputValue] = useState2RM('mailSearchKey', 'doUpdateMailSearchKey');
    const [searchType, setSearchType] = useState2RM('mailSearchType', 'doUpdateMailSearchType');
    const [mailSearchRecord, setMailSearchRecord] = useState2RM('mailSearchRecord', 'doUpdateMailSearchRecord');
    const [searchMail, setSearchMail] = useState2RM('activeSearchMailId', 'doUpdateActiveSearchMailId');
    const [authLock, setAuthLock] = useState2RM('mailFolderIsLock', 'doUpdateMailFolderIsLock');
    const [isShowTreeMenu, setTreeMenu] = useState2RM('mailMoveModalVisiable', 'doUpdateMailMoveModalVisiable');
    const [condition, setCondition] = useState2RM('mailTabs', 'doUpdateMailTabs');
    const [selectedMail, setSelectedMail] = useState2RM('selectedMailId', 'doUpdateSelectedMail');
    const [listModel, setListModel] = useState2RM('defaultMailListSelectedModel', 'doUpdateMailListSelectedModel');
    const [moveModalMailNum, setMoveModalMailNum] = useState2RM('mfModalReadMailNum', 'doUpdateMfModalReadMailNum');
    const [__, setHideMessage] = useState2RM('hideMessage', 'doUpdateMsgHideMessage');
    const [successMsg, setSuccessMsg] = useState2RM('successMsg', 'doUpdateMsgSuccessStr');
    const [failMsg, setFailMsg] = useState2RM('failMsg', 'doUpdateMsgFailStr');
    const [isSearchRecorded, setIsSearchRecorded] = useState2RM('isSearchRecorded', 'doUpdateIsSearchRecordeds');
    const [mailTreeStateMap, setTreeState] = useState2RM('mailTreeStateMap', 'doUpdateMailTreeState');
    const mailTreeStateMapRef = useStateRef(mailTreeStateMap);
    const [searchResultObj] = useState2RM('searchResultObj');
    const mailEntitiesMap = useAppSelector(state => state.mailReducer[MAIL_STORE_REDUX_STATE]);
    const mailReducerState = useAppSelector(state => state.mailReducer);
    const [configMailLayout, setConfigMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const [listIsRefresh, setListIsRefresh] = useState2RM('listIsRefresh');
    const [, setOtherClusterNode] = useState2RM('otherClusterNode');
    const [storeFolderSortInfo, setStoreFolderSortInfo] = useUserLocalStorageState(MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY, 0);
    const [descChecked, setDescChecked] = useState2RM('configMailListShowDesc', 'doUpdateConfigMailListShowDesc');
    const [attachmentChecked, setAttachmentChecked] = useState2RM('configMailListShowAttachment', 'doUpdateConfigMailListShowAttachment');
    const [mailConfigListTightness, setMailConfigListTightness] = useState2RM('configMailListTightness', 'doUpdateConfigMailListTightness');
    const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
    const [, setShowAvator] = useState2RM('configMailListShowAvator', 'doUpdateConfigMailListShowAvator');
    const [, setShowRealList] = useState2RM('', 'doUpdateUseRealList');
    const [, setShowConcreteTime] = useState2RM('', 'doUpdateConfigMailListShowConcreteTime');
    const [, setShowCustomerTab] = useState2RM('configMailListShowCustomerTab', 'doUpdateConfigMailListShowCustomerTab');
    const [, setShowCustomerCompany] = useState2RM('configCustomerCompany');
    const [, setShowRedFlagBg] = useState2RM('configMailListShowRedFlagBg', 'doUpdateConfigMailListShowRedFlagBg');
    const [, setMergeMailOrderDesc] = useState2RM('mergeMailOrderDesc');
    const [realListCurrentPage] = useState2RM('realListCurrentPage');
    const [groupCollapseKeys, setGroupCollapseKeys] = useState2RM('groupCollapseKeys');
    const [searchGroupCollapseKeys, setSearchGroupCollapseKeys] = useState2RM('searchGroupCollapseKeys');
    const dispatch = useAppDispatch();
    const listInitCheckeTiemr = useRef(null);
    const curActiveKey = useAppSelector(state => state.globalReducer.activeKey);
    const [aiAssistSideBarVisiable_sd, setAiAssistSideBarVisiable_sd] = useState2RM('aiAssistSideBarVisiable_sd', 'doUpdateAiAssistVisiable_sd');
    const isMerge = () => mailLogicStateIsMerge(selectedKeys.id, selectedKeys.accountId, isSearching);
    const getRealMailNum = () => {
        let realMailSum = activeIds.length;
        if (isMerge()) {
            realMailSum = 0;
            mailDataList.forEach(item => {
                var _a;
                if (activeIds.includes(item.entry.id)) {
                    realMailSum += (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.threadMessageCount;
                }
            });
        }
        return realMailSum;
    };
    const handleBackToTop = () => {
        reducer.doUpdateMailListScrollTop(0);
    };
    const refreshFolder = (noCache = false, from, _account) => {
        console.log('doMarkMail refreshFolder start');
        promiseIsTimeOut(dispatch(Thunks.refreshFolder({
            noCache,
            from,
            _account,
        })), 'pc_refreshFolder_timeout', {
            from: 'mailBoxEventHander:' + from,
        });
    };
    const refreshFolderDebounce = useCallback(debounce(refreshFolder, 1000), []);
    const getMailListReqParams = (startIndex) => {
        let fid = selectedKeys ? +selectedKeys.id : 1;
        const setting = isMerge();
        let count = MAIL_LIST_MORE_RANGE_COUNT;
        if (startIndex == 0 || selectedKeys.id === FLOLDER.TASK) {
            count = MAIL_LIST_INIT_RANGE_COUNT;
        }
        const param = {
            index: startIndex,
            id: fid,
            count,
            returnModel: true,
            returnTag: true,
        };
        if (selectedKeys && selectedKeys.id === FLOLDER.TAG) {
            param.id = undefined;
            fid = undefined;
        }
        if (tagName === null || tagName === void 0 ? void 0 : tagName.key) {
            param.tag = [tagName === null || tagName === void 0 ? void 0 : tagName.key];
        }
        if (selected === 'UNREAD') {
            param.filter = {
                flags: { read: false },
            };
        }
        else if (selected === 'ATTACHMENT') {
            param.filter = {
                flags: { attached: true },
            };
        }
        else if (selected === 'REDFLAG') {
            param.filter = { label0: 1 };
        }
        else if (folderCanSortByTop(fid, isCorpMail)) {
            param.topFlag = 'top';
        }
        if (selectedKeys.id === FLOLDER.TASK) {
            if (selected === 'ALL') {
                param.filter = {
                    taskTab: 0,
                };
            }
            else if (selected === 'ON') {
                param.filter = {
                    taskTab: 1,
                };
            }
        }
        if (selectedKeys.id === FLOLDER.DEFER) {
            if (selected === 'DEFER') {
                param.filter = {
                    defer: `:${moment().format('YYYYMMDD')}`,
                };
            }
        }
        if (setting) {
            param.checkType = 'checkThread';
        }
        return param;
    };
    const handleSetMarkMail = ({ mark, id, type, hideMessage, key, _account }) => MailApi.doMarkMail(mark, id, type, undefined, undefined, undefined, _account).then(res => {
        if (res && res.succ) {
            !hideMessage &&
                message.success({
                    content: mark ? getIn18Text('BIAOJIYIDUCHENG') : getIn18Text('BIAOJIWEIDUCHENG'),
                    duration: 1,
                    key,
                });
        }
        else {
            !hideMessage &&
                message.error({
                    content: mark ? getIn18Text('BIAOJIYIDUSHI') : getIn18Text('BIAOJIWEIDUSHI'),
                    duration: 1,
                    key,
                });
        }
        if (isCorpMail) {
            try {
                setTimeout(() => {
                    refreshFolder(true, 'handleRedFlagRequest: isCorpMail', _account);
                }, 1000);
            }
            catch (ex) {
                console.error(ex);
            }
        }
        return res;
    });
    const handleBulkMailRead = async ({ mark, map }) => {
        if (map) {
            let reqCount = 0;
            for (let i in map) {
                const idList = map[i];
                try {
                    console.log(4444, 'doMarkMailRead', mark, idList, i);
                    const res = await MailApi.doMarkMail(mark, idList, 'read', undefined, undefined, undefined, i);
                    if (res && res.succ) {
                        reqCount++;
                    }
                }
                catch (e) {
                    console.error('[deleteMailMultiAccount Error]', e);
                }
            }
            const accountCount = Object.keys(map).length;
            if (reqCount >= accountCount) {
                message.success({
                    content: mark ? getIn18Text('BIAOJIYIDUCHENG') : getIn18Text('BIAOJIWEIDUCHENG'),
                    duration: 1,
                    key: '1',
                });
            }
            else if (reqCount == 0) {
                message.error({
                    content: mark ? getIn18Text('BIAOJIYIDUSHI') : getIn18Text('BIAOJIWEIDUSHI'),
                    duration: 2,
                    key: '1',
                });
            }
            else {
                message.warn({
                    content: mark ? '标记已读部分失败' : '标记未读部分失败',
                    duration: 2,
                    key: '1',
                });
            }
            return true;
        }
    };
    const handleBulkMailMark = async ({ mark, map }) => {
        if (map) {
            let reqCount = 0;
            for (let i in map) {
                const idList = map[i];
                try {
                    console.log(4444, 'doMarkMailRedFlag', mark, idList, i);
                    const res = await MailApi.doMarkMail(mark, idList, 'redFlag', undefined, undefined, undefined, i);
                    if (res && res.succ) {
                        reqCount++;
                    }
                }
                catch (e) {
                    console.error('[deleteMailMultiAccount Error]', e);
                }
            }
            const accountCount = Object.keys(map).length;
            if (reqCount >= accountCount) {
                message.success({
                    content: mark ? getIn18Text('BIAOWEIHONGQICHENG') : getIn18Text('QUXIAOHONGQICHENG'),
                    duration: 1,
                    key: '1',
                });
            }
            else if (reqCount == 0) {
                message.error({
                    content: mark ? getIn18Text('BIAOWEIHONGQISHI') : getIn18Text('QUXIAOHONGQISHI'),
                    duration: 2,
                    key: '1',
                });
            }
            else {
                message.warn({
                    content: mark ? '标记红旗部分失败' : '标记红旗部分失败',
                    duration: 2,
                    key: '1',
                });
            }
            return true;
        }
    };
    const handleMailTagChangeRequest = (e) => {
        const { eventData, eventStrData, _account } = e;
        const { mailList = [], tagNames = [], successMsg: _successMsg, failMsg: _failMsg, isNewTag } = eventData;
        setSuccessMsg(_successMsg);
        setFailMsg(_failMsg);
        if (eventStrData === 'tag' || eventStrData === 'untag') {
            try {
                const record = !!localStorage.getItem(MAIL_TAG_GUIDE_LOCAL_KEY);
                if (!record) {
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            visiable: true,
                        },
                        eventStrData: 'showMailTagGuideModal',
                    });
                }
            }
            catch (ex) {
                console.error('[error] showMailTagGuideModal', ex);
            }
            const isAddTag = eventStrData === 'tag';
            const req = isAddTag
                ? {
                    ids: mailList,
                    add: tagNames,
                    isNewTag,
                }
                : {
                    ids: mailList,
                    delete: tagNames,
                };
            const _key = tagNames === null || tagNames === void 0 ? void 0 : tagNames.join(',');
            MailApi.updateMessageTags(req, undefined, undefined, _account)
                .then(() => {
                const addTip = isNewTag ? getIn18Text('XINJIANBINGBIAOJI') : getIn18Text('DABIAOQIANCHENGGONG');
                message.success({
                    content: successMsg || (eventStrData === 'tag' ? addTip : getIn18Text('QUXIAOBIAOQIANCHENG')),
                    duration: 1,
                    key: _key,
                });
                if (isNewTag) {
                    setTimeout(() => {
                        dispatch(Thunks.requestTaglist({
                            account: _account,
                        }));
                    }, 2000);
                }
            })
                .catch(() => {
                message.error({
                    content: failMsg || (eventStrData === 'tag' ? getIn18Text('DABIAOQIANSHIBAI') : getIn18Text('QUXIAOBIAOQIANSHI')),
                    duration: 1,
                    key: _key,
                });
            });
        }
    };
    const handleRedFlagRequest = (e, _mailDataList) => {
        const { eventData, eventStrData, _account } = e;
        const { mark, id, type, hideMessage } = eventData;
        if (eventStrData === 'bulkMark') {
            const { mark, map } = eventData;
            return queueRequest(() => handleBulkMailMark({ map, mark }));
        }
        if (eventStrData === 'bulkRead') {
            const { mark, map } = eventData;
            return queueRequest(() => handleBulkMailRead({ map, mark }));
        }
        if (id == null) {
            console.error('[mailStateChange ERROR]', getIn18Text('MEIYOUCHUANDIYOU'));
            return false;
        }
        const key = typeof id === 'string' || typeof id === 'number' ? id : id.join(',');
        setHideMessage(!!hideMessage);
        if (id.length <= 0) {
            console.log(getIn18Text('BIAOJISHIid'));
            return false;
        }
        if (eventStrData === 'mark' || eventStrData === 'unmark') {
            return MailApi.doMarkMail(mark, id, type, undefined, undefined, undefined, _account).then(res => {
                if (res && res.succ) {
                    !hideMessage &&
                        message.success({
                            content: mark ? getIn18Text('BIAOWEIHONGQICHENG') : getIn18Text('QUXIAOHONGQICHENG'),
                            duration: 1,
                            key,
                        });
                }
                else {
                    !hideMessage &&
                        message.error({
                            content: mark ? getIn18Text('BIAOWEIHONGQISHI') : getIn18Text('QUXIAOHONGQISHI'),
                            duration: 1,
                            key,
                        });
                }
            });
        }
        if (eventStrData === 'defer' || eventStrData === 'undefer') {
            if (eventStrData === 'undefer') {
                MailApi.doMarkMailDefer(id, false, undefined, undefined, _account).then(res => {
                    if (res && res.succ) {
                        message.success({ content: getIn18Text('YICHULI'), duration: 1, key });
                    }
                    else {
                        message.error({ content: getIn18Text('CAOZUOSHIBAI\uFF0C'), duration: 1, key });
                    }
                    refreshFolder(true, 'handleRedFlagRequest:defer', _account);
                });
            }
            else if (eventStrData === 'defer') {
                mailTodoModal.show({
                    mailId: id,
                    isDefer: eventData.isDefer,
                    deferTime: eventData.deferTime,
                    deferNotice: eventData.deferNotice,
                });
            }
        }
        if (eventStrData === 'read' || eventStrData === 'unread') {
            return queueRequest(() => handleSetMarkMail({ mark, id, hideMessage, key, type, _account }));
        }
        if (eventStrData === 'top' || eventStrData === 'unTop') {
            return MailApi.doMarkMail(mark, id, 'top', undefined, undefined, undefined, _account)
                .then(res => {
                if (res.succ) {
                    message.success({
                        content: mark ? getIn18Text('YITIANJIAZHIDING') : getIn18Text('YIQUXIAOZHIDING'),
                        duration: 1,
                        key,
                    });
                }
                else {
                    return Promise.reject();
                }
            })
                .catch(err => {
                var _a;
                if (((_a = err === null || err === void 0 ? void 0 : err.failReason) === null || _a === void 0 ? void 0 : _a.message) === 'FA_OVERFLOW') {
                    SiriusModal.warning({
                        content: getIn18Text('MEIGEWENJIANJIA', { count: MAX_MAILTOP_SUM }),
                        okText: getIn18Text('ZHIDAOLE'),
                        hideCancel: true,
                    });
                }
                else {
                    message.error({
                        content: eventStrData === 'top' ? getIn18Text('ZHIDINGSHIBAI') : getIn18Text('QUXIAOZHIDINGSHI'),
                        duration: 1,
                        key,
                    });
                    loadMoreRows({ startIndex: 0, accountId: _account });
                }
            });
        }
    };
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const handleMailChange = (ev) => {
        var _a;
        try {
            const { eventData, eventStrData, _account } = ev;
            if (eventStrData === 'data') {
                if (locationHelper.testPathMatch('/')) {
                    const { fid } = eventData;
                    const isCurAccount = accountApi.getIsSameSubAccountSync(selectedKeys.accountId, _account) || isMainAccount(selectedKeys.accountId);
                    let canGetMail = fid && (fid === null || fid === void 0 ? void 0 : fid.has(selectedKeys.id)) && isCurAccount && selected == 'ALL';
                    if (folderIdIsAllFolder(selectedKeys.id)) {
                        if (folderIdIsAllTopFolder(selectedKeys.id)) {
                            canGetMail = true;
                        }
                        else {
                            const topAccount = parseAccountFromAllFolderSubAccount(selectedKeys.id);
                            if (accountApi.getIsSameSubAccountSync(selectedKeys.accountId, topAccount)) {
                                canGetMail = true;
                            }
                        }
                    }
                    setTimeout(() => {
                        dispatch(Thunks.doListMailBoxByAccountIds({}));
                    }, 1000);
                    if (canGetMail) {
                        pullLateMail(ev);
                    }
                }
            }
            else if (eventStrData == 'refresh') {
                refreshEmailList({ noCache: true });
                refreshFolder(true, 'handleMailChange: refresh', _account);
            }
            else if (eventStrData == 'mailMergeModelChange') {
                setSelectedMail({ id: '', accountId: '' });
                setSelected('ALL');
                refreshEmailList();
                refreshFolder(false, 'handleMailChange: mailMergeModelChange', _account);
            }
            else if (eventStrData == 'refreshFolder') {
                if (locationHelper.testPathMatch('/')) {
                    const { noCache } = eventData;
                    console.log('doMarkMail receive refreshFolder event');
                    refreshFolderDebounce(noCache, 'handleMailChange: refreshFolder', _account);
                    debouceGetTagList(_account);
                }
            }
            else if (eventStrData == 'syncFolder') {
                if (eventData) {
                    setTreeState({
                        accountId: _account,
                        name: 'mailFolderTreeList',
                        value: eventData,
                    });
                    setTimeout(() => {
                        dispatch(Thunks.doListMailBoxByAccountIds({}));
                    }, 1000);
                }
            }
            else if (eventStrData == 'syncMailTotal') {
                const { total, param } = eventData;
                if (param.id == selectedKeys.id ||
                    (selectedKeys.id == FLOLDER.TAG &&
                        ((_a = param === null || param === void 0 ? void 0 : param.tag) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        param.tag[0] == (tagName === null || tagName === void 0 ? void 0 : tagName.key) &&
                        accountApi.getIsSameSubAccountSync((tagName === null || tagName === void 0 ? void 0 : tagName.accountId) || '', _account))) {
                    setMailTotal(total);
                }
            }
            else if (eventStrData == 'syncDraft') {
                const { id, closeDetail } = eventData;
                setTimeout(() => {
                    dispatch(Thunks.doListMailBoxByAccountIds({}));
                }, 1500);
                if ([2, 3].includes(+selectedKeys.id) || folderIdIsAllDraftFolder(selectedKeys.id) || folderIdIsAllSentFolder(selectedKeys.id)) {
                    if (folderIdIsAllDraftFolder(selectedKeys.id) || folderIdIsAllSentFolder(selectedKeys.id)) {
                        dispatch(Thunks.refreshMailList({ noCache: true, showLoading: false }));
                    }
                    else {
                        syncMailDraft(_account);
                    }
                    if (id && closeDetail && selectedMail.id == id) {
                        setSelectedMail({ id: '', accountId: '' });
                    }
                }
            }
            else if (eventStrData == 'intBoxChanged' || eventStrData == 'intBoxDisplayChanged') {
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    const handleMailStoreRefresh = (ev) => {
        var _a, _b;
        const { eventStrData, eventData } = ev;
        if (eventStrData == 'refreshFromDb') {
            if ((_a = eventData === null || eventData === void 0 ? void 0 : eventData.changedModels) === null || _a === void 0 ? void 0 : _a.length) {
                dispatch(Thunks.getMailListReadStatus({
                    mailIds: (_b = eventData === null || eventData === void 0 ? void 0 : eventData.changedModels) === null || _b === void 0 ? void 0 : _b.map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; }).filter(item => item),
                    req: {},
                }));
            }
        }
    };
    const preferredABTEST = async () => {
        if (isSearching) {
            setSearchSelected('ALL');
            setCondition(filterTabMap.normal);
        }
        else if (!isMainAccount(selectedKeys.accountId)) {
            setCondition(filterTabMap.normal);
        }
        else {
            if (selectedKeys.id === FLOLDER.DEFAULT || selectedKeys.id >= 100) {
                setSelected('ALL');
                setCondition(filterTabMap.normal);
            }
            else if (selectedKeys.id === FLOLDER.TASK) {
                setSelected('ALL');
                setCondition(filterTabMap.task);
            }
            else if (selectedKeys.id === FLOLDER.DEFER) {
                setCondition(filterTabMap.defer);
            }
        }
    };
    const loadMoreRows = ({ startIndex, accountId, searchValue = '', advancedSearch = false, searchKeys = [-33] }, noCache = false) => {
        if (advancedSearch) {
            return dispatch(Thunks.loadAdvanceSearchMailList({
                startIndex,
                noCache,
                accountId,
                filterCond: getFilterCondParams(mailReducerState),
            }));
        }
        if (searchValue) {
            return dispatch(Thunks.loadSearchMailList({
                startIndex,
                noCache,
                accountId,
            }));
        }
        return dispatch(Thunks.loadMailList({
            startIndex,
            noCache,
        }));
    };
    const pullLateMail = ev => {
        dispatch(Thunks.pullLastMail());
    };
    const syncMailDraft = (accountId) => {
        const reqParams = getMailListReqParams(0);
        reqParams.count = MAIL_LIST_INIT_RANGE_COUNT;
        reqParams._account = accountId;
        MailApi.doListMailBoxEntities(reqParams, true).then((result) => {
            if (!result)
                return;
            const res = result;
            if (!res.query)
                return;
            if (res && res.data.length && mailDataList && mailDataList.length) {
                setMailTotal(res.total);
                setMailList(res.data);
            }
        });
    };
    const refreshEmailList = (param = {}) => {
        const { noCache = false, showLoading = true } = param;
        dispatch(Thunks.refreshMailList({
            noCache,
            showLoading,
        }));
    };
    const lc = useLocation();
    useEffect(() => {
        try {
            if (lc === null || lc === void 0 ? void 0 : lc.hash.includes('#mailbox')) {
                const search = new URLSearchParams(lc.hash.split('?')[1]);
                const type = search.get('m');
                const aiType = search.get('aiType');
                const timer = setInterval(() => {
                    if (window.aiAssistantWeb) {
                        clearInterval(timer);
                        setTimeout(() => {
                            if (type == 'subordinate_mail') {
                                storageApi.putSync('atSdTab', new Date().getTime() + '');
                                storageApi.putSync('atSdMsilList', new Date().getTime() + '');
                                dispatch(mailTabActions.doChangeCurrentTab(tabId.subordinate));
                            }
                            if (aiType === 'resign' || aiType === 'subordinate') {
                                setAiAssistSideBarVisiable_sd({
                                    visiable: true,
                                    type: aiType === 'resign' ? 'resign' : 'common',
                                    time: +new Date(),
                                });
                            }
                        }, 3000);
                    }
                }, 1000);
            }
        }
        catch (e) {
            console.log(e);
        }
    }, [lc === null || lc === void 0 ? void 0 : lc.hash]);
    useGlobalEventObserver('mailChanged', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'forceRefreshList') {
            getMailListDataRef(true);
        }
    });
    useEffect(() => {
        refreshFolder(false, 'init');
    }, []);
    useEffect(() => {
        if (isShowTreeMenu) {
            setMoveModalMailNum(getRealMailNum());
        }
    }, [isShowTreeMenu]);
    useEffect(() => {
        if (isSearching) {
        }
        else {
            const res = activeIds.filter(item => !!mailDataList.find(mail => mail.entry.id == item));
            if (res.length != activeIds.length) {
                setActiveIds(res);
            }
        }
    }, [mailDataList, isSearching]);
    useEffect(() => {
        setActiveIds([]);
        setListModel(LIST_MODEL.INIT);
    }, [isSearching, selectedKeys, selected, searchSelected, selectedSearchKeys]);
    const getMailListData = (noCache = false) => {
        if (authLock) {
            setAuthLock(false);
        }
        if (!isSearching) {
            setMailList([]);
            setSelectedMail({ id: '', accountId: '' });
            setListLoading(true);
            loadMoreRows({ startIndex: 0, advancedSearch: isAdvancedSearch }, noCache);
        }
        handleBackToTop();
    };
    const getMailListDataRef = useCreateCallbackForEvent(getMailListData);
    useEffect(() => {
        const desc = MailConfApi.getMailShowDesc();
        setDescChecked(desc);
        const attachment = MailConfApi.getMailShowAttachment();
        setAttachmentChecked(attachment);
        const tightness = MailConfApi.getMailListTightness();
        setMailConfigListTightness(+tightness);
        return () => { };
    }, []);
    useUpdateEffect(() => {
        if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) != -199) {
            getMailListDataRef();
        }
    }, [selectedKeys, selected, isSearching, searchSelected, dateRange]);
    useEffect(() => {
        if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) != -199) {
            getMailListDataRef(true);
        }
    }, []);
    const preTagInfo = useRef();
    useDebounceEffect(() => {
        const preData = preTagInfo.current;
        if (((preData === null || preData === void 0 ? void 0 : preData.key) != (tagName === null || tagName === void 0 ? void 0 : tagName.key) || (preData === null || preData === void 0 ? void 0 : preData.accountId) != (tagName === null || tagName === void 0 ? void 0 : tagName.accountId) || (preData === null || preData === void 0 ? void 0 : preData.selected) != selected) && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == -199) {
            preTagInfo.current = Object.assign(Object.assign({}, tagName), { selected });
            getMailListDataRef(true);
        }
        else {
            preTagInfo.current = null;
        }
    }, [`${tagName === null || tagName === void 0 ? void 0 : tagName.key}${tagName === null || tagName === void 0 ? void 0 : tagName.accountId}`, selectedKeys, selected], { wait: 500 });
    useEffect(() => {
        setTimeout(() => {
            var _a, _b, _c;
            try {
                if (!((_c = (_b = (_a = mailTreeStateMapRef === null || mailTreeStateMapRef === void 0 ? void 0 : mailTreeStateMapRef.current) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.mailFolderTreeList) === null || _c === void 0 ? void 0 : _c.length)) {
                    refreshFolder(true, 'checkFolderInit');
                }
            }
            catch (e) {
                console.error('[Error checkFolderInit]', e);
            }
        }, 8000);
    }, []);
    useEffect(() => {
        setIsSearchRecorded(false);
    }, [searchType]);
    const listIsRefreshRef = useStateRef(listIsRefresh);
    const selectedKeyIdRef = useStateRef(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id);
    const listRefreshTimeoutRef = useRef();
    useEffect(() => {
        if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.SENT) {
            setListIsRefresh(true);
            if (listRefreshTimeoutRef.current) {
                clearTimeout(listRefreshTimeoutRef.current);
            }
            listRefreshTimeoutRef.current = setTimeout(() => {
                if (listIsRefreshRef.current && selectedKeyIdRef.current == FLOLDER.SENT) {
                    setListIsRefresh(false);
                }
            }, 10000);
        }
        else {
            setListIsRefresh(false);
        }
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id]);
    useEffect(() => {
        if (isSearching && !isAdvancedSearch && searchMail.id && mailSearchRecord && !isSearchRecorded) {
            setIsSearchRecorded(true);
            MailApi.doSaveMailSearchRecord({ type: searchType, content: inputValue }).then();
        }
    }, [isSearching, isAdvancedSearch, searchMail, isSearchRecorded, mailSearchRecord]);
    useEffect(() => {
        preferredABTEST();
    }, [isSearching, selectedKeys]);
    useMsgRenderCallback('mailChanged', handleMailChange);
    useMsgRenderCallback('mailStoreRefresh', handleMailStoreRefresh);
    const accountCount = useMemo(() => {
        var _a;
        return ((_a = Object.keys(mailTreeStateMap)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }, [mailTreeStateMap]);
    const debouceGetTagList = useDebounceForEvent(account => dispatch(Thunks.requestTaglist({ account })), 1000, {
        leading: false,
        trailing: true,
    });
    useEffect(() => {
        debouceGetTagList();
    }, [accountCount]);
    useMsgCallback('chooseMailTag', e => {
        const { eventData, _account } = e;
        setTagName({
            key: eventData[0],
            accountId: _account || '',
        });
        setSelectedKeys({
            id: -199,
            accountId: _account,
        });
        setSelected('ALL');
        handleBackToTop();
        const mailTabModel = {
            id: '-1',
            title: transTag2Name(eventData[0]),
            type: tabType.readMain,
            closeable: false,
            isActive: true,
        };
        console.log(123123, mailTabModel);
        dispatch(mailTabActions.doSetTab(mailTabModel));
    });
    useMsgRenderCallback('mailTagChanged', ev => {
        try {
            if (ev) {
                const { eventStrData } = ev;
                if (eventStrData === 'tag' || eventStrData === 'untag') {
                    handleMailTagChangeRequest(ev);
                }
                else {
                    dispatch(Thunks.requestTaglist({ account: ev === null || ev === void 0 ? void 0 : ev._account }));
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    useMsgRenderCallback('mailStatesChanged', ev => {
        try {
            if (ev && !ev.isStick) {
                const { eventStrData, eventData = {} } = ev;
                const { mark, id, type, hideMessage: _hideMessage } = eventData;
                setHideMessage(!!_hideMessage);
                const { tagOnly = false } = eventData;
                if (eventStrData === 'clearCheckedMails') {
                    setActiveIds([]);
                    return;
                }
                handleRedFlagRequest(ev, mailDataList);
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    useMsgRenderCallback('tabsOperation', ev => {
        const { eventStrData, eventData = {} } = ev;
        if (eventStrData === 'doSetTab') {
            const { id } = eventData;
            const mail = mailEntitiesMap[id];
            if (mail) {
                let title = '无主题';
                try {
                    title = mail.entry.title.replace('<b>', '').replace('</b>', '') || '无主题';
                }
                catch (e) {
                    console.error('[Error reg]', e);
                }
                const mailTabModel = Object.assign(Object.assign({}, eventData), { title });
                dispatch(mailTabActions.doSetTab(mailTabModel));
            }
            else {
                console.error('tabsOperation error');
            }
        }
    });
    useMsgCallback('todoChange', ev => {
        reducer.doTaskMailOperation(ev);
    });
    const handlerContactNotify = () => {
        refreshFolder(false, 'handlerContactNotify');
    };
    useMsgRenderCallback('contactPersonalMarkNotify', handlerContactNotify);
    useEffect(() => {
        mailConfApi.doGetUserAttr([MailSettingKeys.nForward]).then(res => {
            const { ntes_option } = res;
            if (ntes_option) {
                const key = ntes_option[15];
                setMergeMailOrderDesc(!!key);
            }
        });
    }, []);
    useEffect(() => {
        reducer.doUpdateMailListScrollTop(0);
    }, [realListCurrentPage]);
    useEffect(() => {
        const desc = mailConfApi.getMailShowDesc();
        setDescChecked(desc);
        const attachment = mailConfApi.getMailShowAttachment();
        setAttachmentChecked(attachment);
        const avator = mailConfApi.getMailShowAvator();
        setShowAvator(!process.env.BUILD_ISEDM && avator);
        const showConcreteTime = mailConfApi.getShowConcreteTime();
        setShowConcreteTime(showConcreteTime);
        if (process.env.BUILD_ISEDM) {
            const showCustomerTab = mailConfApi.getShowCustomerTab();
            setShowCustomerTab(showCustomerTab);
            const showCustomerCompany = mailConfApi.getShowCustomerCompany();
            setShowCustomerCompany(showCustomerCompany);
        }
        const redFlagBgStore = storageApi.getSync('mail_list_red_flag_bg_enabled');
        setShowRedFlagBg(redFlagBgStore && redFlagBgStore.suc && redFlagBgStore.data === 'true');
    }, []);
    const getExpiredAccountListAndRefreshFolder = async (refresh) => {
        const subAccounts = await accountApi.getSubAccounts({ expired: true });
        if (subAccounts && subAccounts.length) {
            const agentEmailList = subAccounts.filter(a => a.expired).map(a => a.agentEmail);
            setExpiredAccountList(agentEmailList);
        }
        else {
            setExpiredAccountList([]);
        }
        setTimeout(() => {
            if (refresh) {
                refreshFolder(true, 'getExpiredAccountListAndRefreshFolder');
            }
        }, 0);
    };
    const md = useRef();
    const accountExpiredTip = () => {
        if (md.current) {
            md.current.destroy();
        }
        md.current = SiriusModal.info({
            title: getIn18Text('accountExpiredTip'),
            okCancel: !0,
            cancelText: getIn18Text('QUXIAO'),
            onCancel: () => {
                md.current.destroy();
            },
            okText: getIn18Text('recheck'),
            onOk: () => {
                navigate('/#setting', { state: { currentTab: 'mail', mailConfigTab: 'OTHER' } });
                md.current.destroy();
            },
        });
    };
    useMsgRenderCallback('SubAccountWindowReady', ev => {
        try {
            getExpiredAccountListAndRefreshFolder(true);
        }
        catch (e) {
            console.error(e);
        }
    });
    useMsgRenderCallback('SubAccountDeleted', ev => {
        try {
            getExpiredAccountListAndRefreshFolder(true);
        }
        catch (e) {
            console.error(e);
        }
    });
    useMsgRenderCallback('SubAccountLoginExpired', ev => {
        try {
            getExpiredAccountListAndRefreshFolder(false);
        }
        catch (e) {
            console.error(e);
        }
    });
    useEffect(() => {
        if (expiredAccountList.includes(selectedKeys.accountId) || expiredAccountList.includes(currentTabAccountId)) {
            accountExpiredTip();
        }
    }, [expiredAccountList, selectedKeys, currentTabAccountId]);
    useMsgRenderCallback('mailRealListTotalChanged', ev => {
        if (ev && ev.eventData) {
            const totalCount = ev.eventData.netWorkTotal;
            setMailTotal(totalCount);
        }
    });
    const { setMailGlobalHk } = useContext(MailModuleHKContent) || {};
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const [accountHKTagMap, setAccountHKTagMap] = useState({});
    const handleMailTagFromHK = useCreateCallbackForEvent((hkKey, tagAccountName) => {
        var _a, _b, _c, _d;
        try {
            if (currentTabType != tabType.read && currentTabType != tabType.readMain) {
                return;
            }
            let ids = activeIds;
            if (currentTabType == tabType.read) {
                ids = [(_a = currentTab === null || currentTab === void 0 ? void 0 : currentTab.extra) === null || _a === void 0 ? void 0 : _a.originMid];
            }
            const mails = ids.map(id => mailEntitiesMap[id]);
            const mailAccount = ((_c = systemApi.getCurrentUser((_b = mails[0]) === null || _b === void 0 ? void 0 : _b._account)) === null || _c === void 0 ? void 0 : _c.id) || '';
            const tagAccount = ((_d = systemApi.getCurrentUser(tagAccountName)) === null || _d === void 0 ? void 0 : _d.id) || '';
            const tagName = accountHKTagMap[mailAccount][hkKey];
            const isAll = mails.every(item => item.tags && item.tags.includes(tagName));
            if (tagAccount == mailAccount && mails && mails.length) {
                eventApi.sendSysEvent({
                    eventName: 'mailTagChanged',
                    eventData: {
                        tagNames: [tagName],
                        mailList: ids,
                        tagIds: [tagName],
                    },
                    eventStrData: isAll ? 'untag' : 'tag',
                    _account: mailAccount,
                });
            }
        }
        catch (e) {
            console.error('[error] handleMailTagFromHK', e);
        }
    });
    const handleMailTagHK = useCreateCallbackForEvent(() => {
        const allAccountMap = mailTagHotKeysMap;
        const map = {};
        const ahkTagMap = {};
        for (let i in allAccountMap) {
            const tagHkMap = allAccountMap[i];
            ahkTagMap[i] = {};
            if (tagHkMap) {
                for (let n in tagHkMap) {
                    const hkList = tagHkMap[n];
                    const key = hkList.join('+');
                    ahkTagMap[i][key] = n;
                    map[key.toLowerCase()] = (e) => {
                        e.preventDefault();
                        handleMailTagFromHK(key, i);
                    };
                }
            }
        }
        setAccountHKTagMap(ahkTagMap);
        setMailGlobalHk && setMailGlobalHk(MAIL_HOTKEY_MODULE_TYPE.MAIL_TAG, map);
    });
    useMsgRenderCallback('mailMenuOper', ev => {
        const { eventStrData } = ev;
        if (eventStrData === 'reloadHotKey') {
            handleMailTagHK();
        }
    });
    useEffect(() => {
        handleMailTagHK();
    }, [mailTagHotKeysMap]);
    const debounceGetDisplayName = useDebounceForEvent((accountList) => {
        if (accountList === null || accountList === void 0 ? void 0 : accountList.length) {
            dispatch(Thunks.getUserFolderAlias({ accountList }));
        }
    }, 500, {
        leading: false,
        trailing: true,
    });
    const accountList = useMemo(() => {
        try {
            if (mailTreeStateMap) {
                const list = [];
                for (let i in mailTreeStateMap) {
                    if (i != 'main') {
                        list.push(i);
                    }
                }
                return list;
            }
        }
        catch (e) {
            console.error('accountList error', e);
        }
        return [];
    }, [mailTreeStateMap]);
    useEffect(() => {
        if (accountList.length) {
            debounceGetDisplayName(accountList);
        }
    }, [accountList.join(',')]);
    const hkParams = useMemo(() => {
        return {
            handler: {
                [HotKeysType.SOUSUOYOUJIAN]: e => {
                    e && e.preventDefault();
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventStrData: 'searchInputFocus',
                    });
                },
                [HotKeysType.XINJIANXIEXIN]: () => {
                    MailApi.doWriteMailToContact();
                },
                [HotKeysType.FASONGYOUJIAN]: e => {
                    if (e.key === 'Enter') {
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: {},
                            eventStrData: 'sendMail',
                        });
                    }
                },
                [HotKeysType.BAOCUNCAOGAO]: e => {
                    e && e.preventDefault();
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {},
                        eventStrData: 'saveDraft',
                    });
                },
            },
        };
    }, []);
    useRegistMailHK(MAIL_HOTKEY_MODULE_TYPE.MAIL_BOX, hkParams);
    const lock = useRef(false);
    useUpdateEffect(() => {
        var _a;
        if (!lock.current) {
            let count = 0;
            for (let i in mailTreeStateMap) {
                if (i != 'main') {
                    count++;
                }
            }
            if (count > 0) {
                try {
                    let res = (_a = storageApi.getSync(MAIL_FOLDER_SELECTED_LOCAL_KEY)) === null || _a === void 0 ? void 0 : _a.data;
                    if (res) {
                        const config = JSON.parse(res);
                        if (config && config.id) {
                            return;
                        }
                    }
                }
                catch (e) {
                    console.error('[error] lastSelectedFolder local', e);
                }
                try {
                    setSelectedKeys({
                        id: FLOLDER.ALL_RECEIVE,
                        accountId: '',
                    });
                }
                catch (e) {
                    console.error('[error] doUpdateSelectedKey local', e);
                }
            }
        }
    }, [mailTreeStateMap]);
    const accountKey = useMemo(() => {
        return Object.keys(mailTreeStateMap);
    }, [mailTreeStateMap]);
    useEffect(() => {
        const accountList = Object.keys(mailTreeStateMap);
        const mainAccountNode = [];
        const otherNode = [];
        const mainAccountInfo = systemApi.getCurrentUser();
        accountList.forEach(account => {
            if (!isMainAccount(account)) {
                const accountInfo = systemApi.getCurrentUser(account);
                if (accountInfo) {
                    if (accountInfo.node == (mainAccountInfo === null || mainAccountInfo === void 0 ? void 0 : mainAccountInfo.node)) {
                        mainAccountNode.push(Object.assign({}, accountInfo));
                    }
                    else {
                        otherNode.push(Object.assign({}, accountInfo));
                    }
                }
            }
        });
        setOtherClusterNode(otherNode);
        if (storeFolderSortInfo != 0) {
            setStoreFolderSortInfo(0);
        }
        if (otherNode.length) {
            trackApi.track('pcMail_merge_folderTree_cross_node', { account: otherNode.map(item => item.id) });
        }
    }, [accountKey]);
    useEffect(() => {
        if (isSearching) {
            setGroupCollapseKeys([]);
        }
        else {
            setSearchGroupCollapseKeys([]);
        }
    }, [isSearching]);
    useEffect(() => {
        if (isSearching) {
            setSearchGroupCollapseKeys([]);
        }
        setGroupCollapseKeys([]);
    }, [selectedKeys, selected]);
    useMsgRenderCallback('mailChanged', (ev) => {
        const { eventStrData } = ev;
        if (eventStrData == 'mailMergeModelChange') {
            setGroupCollapseKeys([]);
            setSearchGroupCollapseKeys([]);
        }
    });
    const searchResultObjHash = useMemo(() => {
        return searchResultObj.key + searchResultObj._account + simpleHash(searchResultObj.filterCond) + simpleHash(selectedSearchKeys);
    }, [searchResultObj, selectedSearchKeys]);
    useEffect(() => {
        if (isSearching) {
            setSearchGroupCollapseKeys([]);
        }
    }, [searchResultObjHash]);
    useEffect(() => {
        setGroupCollapseKeys([]);
        setSearchGroupCollapseKeys([]);
    }, [realListCurrentPage]);
    return React.createElement(React.Fragment, null);
};
export default MailBoxEventHander;
